/**
 * @generated SignedSource<<a41dc4d6004d46f4ea65dabc1e78516a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type agendaAppointmentDrawer_appointment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"agendaAppointmentDrawerData_appointment" | "agendaAppointmentDrawerPatient_appointment">;
  readonly " $fragmentType": "agendaAppointmentDrawer_appointment";
};
export type agendaAppointmentDrawer_appointment$key = {
  readonly " $data"?: agendaAppointmentDrawer_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"agendaAppointmentDrawer_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "agendaAppointmentDrawer_appointment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "agendaAppointmentDrawerPatient_appointment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "agendaAppointmentDrawerData_appointment"
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "89a59fbecf84b48cdf56ef9294bcdbfd";

export default node;
